import dayjs from "dayjs";
import { IActivity } from "./TemplateMovementsCheck.types";

export function formatDate(
  dateToFormat: string,
  formatType?: "timestamp" | "date" | "timestamp_2"
) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    const date = dayjs(dateToFormat);

    const type = !formatType ? "date" : formatType;

    return type === "date"
      ? date.format(`DD/MM/YYYY`)
      : date.format("DD/MM/YYYY - HH:mm:ss");
  } catch (error) {
    const type = !formatType ? "date" : formatType;

    return type === "date"
      ? "-"
      : type === "timestamp"
      ? "--/--/---- --:--:--"
      : "-";
  }
}

export function formatType(payload: string) {
  if (payload === "EMPLOYEE") return "Titular";

  if (payload === "DEPENDENT") return "Dependente";

  return "-";
}

export function formatMovementType(payload: string) {
  if (payload === "inclusion") return "Inclusão";

  if (payload === "exclusion") return "Exclusão";

  if (payload === "change") return "Alteração";

  if (payload === "transfer") return "Transferência";

  if (payload === "maintenance") return "Manutenção";

  return "-";
}

export function formatStatus(status: string) {
  if (status === "READY")
    return {
      label: "Pronto",
      backgroundColor: "#0288D114",
      color: "#01579B",
    };

  if (status === "SKIPED")
    return {
      label: "Retido",
      backgroundColor: "#BA1A1A14",
      color: "#BA1A1A",
    };

  if (status === "DELAYED")
    return {
      label: "Em espera",
      backgroundColor: "#EF6C0014",
      color: "#EF6C00",
    };

  if (status === "RETAINED")
    return {
      label: "Retificar",
      backgroundColor: "#0F0F1E14",
      color: "#0F0F1E",
    };

  return {
    label: "-",
    backgroundColor: "#F5F5F5",
    color: "#616161",
  };
}

export function formatActivityStatus(status: string) {
  if (status === "IDLE")
    return {
      label: "Aguardando",
      backgroundColor: "#191C1A14",
      color: "#191C1A",
    };

  if (status === "PENDING")
    return {
      label: "Pendente",
      backgroundColor: "#EF6C0014",
      color: "#EF6C00",
    };

  if (status === "SUCCESS")
    return {
      label: "Executado",
      backgroundColor: "#2E7D3214",
      color: "#2E7D32",
    };

  if (status === "FAILED")
    return {
      label: "Falhou",
      backgroundColor: "#ff7d7d3b",
      color: "#a30000",
    };

  return {
    label: "Aguardando",
    backgroundColor: "#F5F5F5",
    color: "#616161",
  };
}

export function sortApps(activities: IActivity[]) {
  const order = [
    "dag_excecao",
    "app_transfer",
    "app_change",
    "app_exclusion",
    "app_inclusion",
  ];

  const priority = Object.fromEntries(order.map((slug, i) => [slug, i]));

  return activities.sort((a, b) => {
    const pa = priority[a.slug] ?? Number.MAX_SAFE_INTEGER;
    const pb = priority[b.slug] ?? Number.MAX_SAFE_INTEGER;
    return pa - pb;
  });
}

export function sortRelatedActivities(activities: IActivity[]) {
  const order = [
    "prepare_people_data",
    "process_contract_rules",
    "employee_movements",
    "app_approve",
    "app_inclusion",
    "app_exclusion",
    "app_change",
    "app_transfer",
    "dag_excecao",
  ];

  const priority = Object.fromEntries(order.map((slug, i) => [slug, i]));

  return activities.sort((a, b) => {
    const pa = priority[a.slug] ?? Number.MAX_SAFE_INTEGER;
    const pb = priority[b.slug] ?? Number.MAX_SAFE_INTEGER;
    return pa - pb;
  });
}
